import clsx from 'clsx';
import { IconSource } from 'types/icons';
import { useDisableClick } from 'utilities/interactions';

import { Icon } from 'components/Icon';
import { Spinner } from 'components/Spinner';
import { Text } from 'components/Text';

import styles from './ReactionButton.module.scss';

interface ReactionButtonProps {
  icon: IconSource;
  disabled?: boolean;
  active?: boolean;
  /** Replaces button text with a spinner while a background action is being performed */
  loading?: boolean;
  count?: number;
  ariaLabel?: string;
  onClick?: () => void;
}

export function ReactionButton({
  icon,
  disabled,
  active,
  loading,
  count,
  ariaLabel,
  onClick,
}: ReactionButtonProps) {
  const isDisabled = disabled || loading;
  const className = clsx(
    styles.ReactionButton,
    isDisabled && styles.disabled,
    loading && styles.loading,
  );

  const handleClick = useDisableClick(disabled, onClick);

  const contentMarkup = (
    <div className={styles.Content}>
      <Icon source={icon} color={active ? 'default' : 'none'} />
      {String(count) && <Text size="small">{count}</Text>}
    </div>
  );

  const spinnerMarkup = loading ? (
    <div className={styles.Spinner}>
      <Spinner size="small" />
    </div>
  ) : null;

  return (
    <button
      className={className}
      disabled={disabled}
      aria-label={ariaLabel}
      onClick={handleClick}
    >
      {contentMarkup}
      {spinnerMarkup}
    </button>
  );
}
